import { createFileRoute } from '@tanstack/react-router';

import { SessionsPage } from '@/features/auth';

/** Own sessions only (x-permission: authenticated); every signed-in user may open it. */
export const Route = createFileRoute('/_app/account/sessions')({
  staticData: { crumb: 'auth:sessions.title' },
  component: SessionsPage,
});
